import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';

import { IqTicketStats } from '../../domain/iq-aggregated-dashboard.model';

@Component({
  selector: 'app-iq-ticket-tiles',
  templateUrl: './iq-ticket-tiles.component.html',
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IqTicketTilesComponent {
  readonly metrics = input<IqTicketStats | null>(null);

  readonly isLoading = input(false);

  readonly formattedMttr = computed(() => {
    const m = this.metrics();
    if (m?.mttrDays == null) return 'N/A';

    const totalDays = m.mttrDays;
    const wholeDays = Math.floor(totalDays);
    const remainderDays = totalDays - wholeDays;
    const totalSeconds = Math.round(remainderDays * 24 * 60 * 60);
    const h = Math.floor(totalSeconds / 3600);
    const min = Math.floor((totalSeconds % 3600) / 60);
    const sec = totalSeconds % 60;
    const pad = (n: number) => n.toString().padStart(2, '0');

    return `${wholeDays}D ${pad(h)}:${pad(min)}:${pad(sec)}`;
  });
}
